import axios, { type AxiosInstance } from 'axios';

export function createHttpClient(clientId: string): AxiosInstance {
  return axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    headers: {
      'X-Client-Id': clientId,
    },
  });
}
